export default Object.freeze({
    LOCATION: 'Location',
    EQUIPMENT: 'Equipment',
    PART_ENTRY: 'PartEntry',
    USER: 'User',
    EQUIPMENT_TYPE: 'EquipmentType',
    TERMINAL: 'Terminal',
    ISSUE: 'Issue'
})